import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 企画確定済み媒体数取得
 *
 * @export 
 * @class CountFixtationService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class CountFixtationService extends PlessJsonResponderSub<any> {

  private successFunc: Function;
  private catalogId: string;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CountFixtationService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CatalogId: this.catalogId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param catalogId
   * @memberof CountFixtationService
   */
  execute(catalogId: string, successFunc: Function = null): void {
    this.catalogId = catalogId;
    this.successFunc = successFunc;
    this.send('countFixtation', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof CountFixtationService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
